import orderBy from "lodash/orderBy";

import type { IVulnerabilityPoliciesData } from "./types";

const filterData = (
  policies: IVulnerabilityPoliciesData[],
  treatmentValue: "ACCEPTED_UNDEFINED" | "ACCEPTED",
): IVulnerabilityPoliciesData[] =>
  orderBy(
    policies.filter(
      (policy: IVulnerabilityPoliciesData): boolean =>
        policy.treatmentAcceptance === treatmentValue,
    ),
    "lastStatusUpdate",
    "desc",
  );

export { filterData };
